<template>
  <div class="cities-view">
    <template v-if="loading">
      <loader width="48px" height="48px" stroke="#4C4C4C" />
    </template>
    <template v-else>
      <table-actions>
        <button @click="addNew">Создать</button>
      </table-actions>
      <table-element v-bind="tableOptions" :actions="true" v-on:rowClick="rowClick">
        <template #title="{ value, row }">
          <template v-if="editingRowId === row.id">
            <div class="flex-row">
              <input
                type="text"
                v-model="editingValue"
                placeholder="Введите название города"
                @click.stop
                @keyup.enter="saveRow(row.id)"
              />
              <button @click.stop="toggleEditing(row.id, row.title)">Отмена</button>
              <button v-if="row.id" class="red" @click.stop="removeRow(row.id)">Удалить</button>
            </div>
          </template>
          <template v-else>
            <span>{{ value }}</span>
          </template>
        </template>
        <template #actions="{ row, value }">
          <template v-if="editingRowId === row.id">
            <button @click.stop="saveRow(row.id)">✓</button>
          </template>
          <template v-else>
            <button @click.stop="toggleEditing(row.id, row.title)">✎</button>
          </template>
        </template>
      </table-element>

      <!-- <paginator :model="meta.list_data" @change="changePage" /> -->
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import TableElement from '@/components/common/TableElement';
import TableActions from '@/components/common/TableActions';

export default {
  name: 'cities-view',

  components: {
    TableElement,
    TableActions,
  },

  computed: {
    ...mapGetters({
      loading: 'config/loading',
      error: 'config/error',
      list: 'dealers/cities',
    }),

    tableOptions() {
      return {
        columns: [{ label: 'Название', name: 'title', width: '60%' }],

        list: [...this.prependList, ...this.list],

        order: {},
      };
    },
  },

  async beforeMount() {
    if (!this.list.length) {
      await this.getConfig();
    }
  },

  methods: {
    ...mapActions({
      getConfig: 'dealers/getConfig',
      save: 'dealers/citiesSave',
      create: 'dealers/citiesCreate',
      remove: 'dealers/citiesRemove',
    }),

    toast(msg, type) {
      if (type === 'success') {
        this.$snotify.success(msg, null, {
          showProgressBar: false,
        });
      }
      if (type === 'error') {
        this.$snotify.error(msg, null, {
          showProgressBar: false,
        });
      }
    },

    addNew() {
      const newCity = {
        id: null,
        title: '',
      };
      this.prependList = [];
      this.prependList.push(newCity);
      this.editingValue = null;
      this.editingRowId = null;
    },

    toggleEditing(rowId, value) {
      this.prependList = [];

      if (this.editingRowId === rowId) {
        this.editingRowId = null;
        this.editingValue = null;
      } else {
        this.editingRowId = rowId;
        this.editingValue = value;
      }
    },

    async saveRow(rowId) {
      if (rowId) {
        const saveErr = await this.save({
          id: rowId,
          title: this.editingValue,
        });

        if (!saveErr) {
          this.toast('Изменения сохранены.', 'success');
        } else {
          this.toast('Произошла ошибка.', 'error');
        }
      } else {
        const createErr = await this.create({
          title: this.editingValue,
        });

        if (!createErr) {
          this.toast('Город успешно создан.', 'success');
        } else {
          this.toast('Произошла ошибка.', 'error');
        }
      }
    },

    async removeRow(rowId) {
      const err = await this.remove({
        id: rowId,
      });

      if (!err) {
        this.toast('Запись успешно удалена.', 'success');
      } else {
        if (err.conflict) {
          this.toast(
            'Невозможно удалить город, используемый в дилерах',
            'error'
          );
        } else {
          this.toast('Произошла ошибка.', 'error');
        }
      }
    },

    rowClick(rowId) {
      const row = this.list.find(row => row.id === rowId);

      this.toggleEditing(row.id, row.title);
    },
  },

  data() {
    return {
      editingRowId: false,
      editingValue: null,
      prependList: [],
    };
  },
};
</script>

<style lang="scss" scoped>
.cities-view {
  position: relative;
  min-height: 100%;

  input,
  button {
    height: 30px;
  }
}

.flex-row {
  display: flex;

  > * {
    margin-right: 8px;
  }
}
</style>
